import {
  Dialog,
  DialogActions,
  DialogContent,
  Menu,
  Typography,
} from "@mui/material";
import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  CancelButton,
  Accept,
  Reject,
  PrimaryButton,
  PrimaryLoadingButton,
} from "../../css components/Button";
import { useAxios, useComponent } from "../../../hooks";
import pages from "../../../constants/pages";
import DropDownMenu from "./DropDownMenu";
import ActionPopUp from "./ActionPopup";

export default function ActionButton({
  ID = "",
  editState,
  setEditState,
  formikProps,
  audienceSizing,
  setAudienceSizing,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { alert } = useComponent();

  const [dialog, setDialog] = useState({ state: false });
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [isdownloadAudience, setIsDownloadAudience] = useState(false);
  const [actionPopup, setActionPopup] = useState({
    state: false,
    data: {},
    status: "",
  });

  const [loading, setLoading] = useState({
    REJECTED: false,
    APPROVE: false,
    PENDING: false,
    AUDIENCE: false,
    ACCEPTED: false,
    CAMPAIGNLIVE: false,
  });

  function handleCancel() {
    if (editState && !!ID) {
      setEditState(!editState);
      formikProps.handleReset();
    } else {
      navigate(-1);
    }
  }

  return (
    <Fragment>
      <CancelButton
        onClick={handleCancel}
        variant="outlined"
        style={{ marginRight: "10px" }}
      >
        {"Back"}
      </CancelButton>
      {formikProps.values?.campaignID &&
        formikProps.values?.status === "ACTIVE" &&
        formikProps.values.permissionSettings.display_stats && (
          <PrimaryButton
            style={{ marginRight: "10px" }}
            onClick={() =>
              navigate(
                pages.analytics.route +
                  formikProps.values.campaignID +
                  "?campaignName=" +
                  formikProps.values?.campaign_name?.value
              )
            }
            variant="contained"
          >
            Analytics
          </PrimaryButton>
        )}
      {((formikProps.values?.status !== "ACTIVE" &&
        formikProps.values.adminApprovalStatus === "REQUESTED") ||
        formikProps.values.adminApprovalStatus === "REJECTED") && (
        <Accept
          style={{ marginRight: "10px" }}
          size="large"
          variant="contained"
          loading={loading.ACCEPTED}
          onClick={() =>
            setActionPopup({
              state: true,
              status: "Approve",
              data: {
                requestStatus: "ACCEPTED",
              },
            })
          }
        >
          Approve
        </Accept>
      )}
      {((formikProps.values?.status !== "ACTIVE" &&
        formikProps.values.adminApprovalStatus === "ACCEPTED") ||
        formikProps.values.adminApprovalStatus === "REQUESTED") && (
        <Reject
          style={{ marginRight: "10px" }}
          size="large"
          variant="contained"
          loading={loading.REJECTED}
          onClick={() =>
            setActionPopup({
              state: true,
              status: "Reject",
              data: {
                requestStatus: "REJECTED",
                rejectReason: "",
              },
            })
          }
        >
          Reject
        </Reject>
      )}
      {/* // (formikProps.values.adminApprovalStatus === "ACCEPTED" || //
      !formikProps.values.permissionSettings?.sent_for_approval) && ( */}
      {formikProps.values?.status !== "ACTIVE" && (
        <Fragment>
          <PrimaryLoadingButton
            variant="contained"
            size="large"
            loading={loading.AUDIENCE}
            style={{ marginRight: "10px" }}
            onClick={(event) => {
              setMenuAnchor(event.currentTarget);
            }}
          >
            Audience
          </PrimaryLoadingButton>

          <Menu
            style={{ marginTop: "10px" }}
            open={!!menuAnchor}
            anchorEl={menuAnchor}
            onClose={() => setMenuAnchor(null)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <DropDownMenu
              setAudienceSizing={setAudienceSizing}
              audienceSizing={audienceSizing}
              setIsDownloadAudience={setIsDownloadAudience}
              formikProps={formikProps}
              setLoading={setLoading}
              setMenuAnchor={setMenuAnchor}
            />
          </Menu>
        </Fragment>
      )}
      {formikProps.values.status === "ACTIVE" &&
        formikProps.values.permissionSettings?.add_campaign_stats && (
          <PrimaryLoadingButton
            loading={isdownloadAudience}
            style={{ marginRight: "10px" }}
            size="large"
            variant="contained"
            onClick={() =>
              navigate(
                pages.addCampaignStats.route + formikProps.values.campaignID
              )
            }
          >
            Add Campaign Stats
          </PrimaryLoadingButton>
        )}
      {formikProps.values.IsManualCampaignLive &&
        formikProps.values?.status !== "ACTIVE" &&
        formikProps.values.adminApprovalStatus !== "REJECTED" && (
          <PrimaryButton
            loading={loading.CAMPAIGNLIVE}
            style={{ marginRight: "10px" }}
            size="large"
            variant="contained"
            onClick={() => setDialog({ state: true })}
          >
            Campaign Live
          </PrimaryButton>
        )}
      {formikProps.values.campaignAdminStatus === 0 && (
        <Reject
          style={{ marginRight: "10px" }}
          size="large"
          variant="contained"
          loading={loading.REJECTED}
          onClick={() => handleCampaignStatus("REJECTED")}
        >
          Reject
        </Reject>
      )}
      {formikProps.values.campaignAdminStatus === 0 && (
        <Accept
          style={{ marginRight: "10px" }}
          size="large"
          variant="contained"
          loading={loading.APPROVE}
          onClick={() => handleCampaignStatus("APPROVE")}
        >
          Active
        </Accept>
      )}
      <ConfirmPopup />
      <ActionPopUp
        handleApprovalStatus={handleApprovalStatus}
        actionPopup={actionPopup}
        setActionPopup={setActionPopup}
        loading={loading}
      />
    </Fragment>
  );

  function handleApprovalStatus() {
    setLoading((prev) => ({
      ...prev,
      [actionPopup.data.requestStatus]: true,
    }));

    axios({
      url: "/action/campaign/requests",
      method: "POST",
      data: {
        campaign_id: formikProps.values.campaignID,
        request_status: actionPopup.data.requestStatus,
        reject_reason: actionPopup.data?.rejectReason,
      },
    }).then((response) => {
      setLoading((prev) => ({
        ...prev,
        [actionPopup.data.requestStatus]: false,
      }));
      if (response.status) {
        dispatch(alert.success(response.message?.displayMessage));
        formikProps.setValues((prev) => ({
          ...prev,
          campaignStatus: response.data?.campaignStatus,
          adminApprovalStatus: actionPopup.data.requestStatus,
        }));
      }

      setActionPopup({ state: false });
    });
  }

  function handleCampaignStatus(status) {
    setLoading((prev) => ({
      ...prev,
      [status]: true,
    }));
    axios({
      url: "/user/campaigns/changeAdminCampaignStatus",
      method: "PUT",
      disableRedirect: true,
      data: {
        campaignId: formikProps.values.campaignID,
        status: status,
      },
    }).then((response) => {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          campaignAdminStatus: 1,
        }));

        dispatch(alert.success(`Campaign ${status} successfully!`));
      }

      setLoading((prev) => ({
        ...prev,
        [status]: true,
      }));
    });
  }

  function ConfirmPopup() {
    function handleLive() {
      setLoading((prev) => ({
        ...prev,
        CAMPAIGNLIVE: true,
      }));
      axios({
        url: "/live/campaign/request",
        method: "POST",
        data: {
          campaign_id: formikProps.values.campaignID,
        },
      }).then((response) => {
        if (response.status) {
          dispatch(alert.success(response.message.displayMessage));
          formikProps.setValues((prev) => ({
            ...prev,
            status: response.data.status,
            campaignStatus: response.data.status,
          }));
          setLoading((prev) => ({
            ...prev,
            CAMPAIGNLIVE: false,
          }));
          setDialog({ state: false });
        }
      });
    }
    return (
      <Dialog
        fullWidth
        maxWidth="sm"
        open={dialog.state}
        onClose={() => setDialog({ state: false })}
      >
        <DialogContent>
          <Typography fontSize={"15px"}>
            Are you sure you want to live campaign?
          </Typography>
        </DialogContent>

        <DialogActions>
          <CancelButton
            variant="outlined"
            onClick={() => setDialog({ state: false })}
          >
            Cancel
          </CancelButton>

          <PrimaryLoadingButton
            loading={loading.CAMPAIGNLIVE}
            onClick={handleLive}
            variant="contained"
          >
            Confirm
          </PrimaryLoadingButton>
        </DialogActions>
      </Dialog>
    );
  }
}
